import InputBasic from './InputBasic'
import InputBlack from './InputBlack'

const Input = {
  Basic: InputBasic,
  Black: InputBlack,
}

export default Input
